import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import IconButton from "@widget/buttons/IconButton";
import { UXPContext } from "@core/context/Context";
/**
 * The object search summary on one row. When the cards don't fit it scrolls sideways,
 * with previous / next buttons that move one visible width.
 */
const SummaryStrip = ({ children }) => {
    const context = useContext(UXPContext);
    const scrollRef = useRef(null);
    const [canPrev, setCanPrev] = useState(false);
    const [canNext, setCanNext] = useState(false);
    const update = useCallback(() => {
        const el = scrollRef.current;
        if (!el)
            return;
        setCanPrev(el.scrollLeft > 1);
        setCanNext(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    }, []);
    useEffect(() => {
        const el = scrollRef.current;
        if (!el)
            return;
        update();
        const observer = new ResizeObserver(update);
        observer.observe(el);
        if (el.firstElementChild)
            observer.observe(el.firstElementChild);
        return () => observer.disconnect();
    }, [update]);
    const scroll = (dir) => { var _a; return (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollBy({ left: dir * scrollRef.current.clientWidth * 0.8, behavior: 'smooth' }); };
    return _jsxs("div", { className: "uxpcore_osc__summary_container", children: [_jsx("div", { className: "uxpcore_osc__summary_scroll", ref: scrollRef, onScroll: update, children: children }), canPrev && _jsx(IconButton, { className: "uxpcore_osc__summary_prev", icon: "phr caret-left", variant: "secondary", tooltip: context.$L('uxp-core.text.previous'), onClick: () => scroll(-1) }), canNext && _jsx(IconButton, { className: "uxpcore_osc__summary_next", icon: "phr caret-right", variant: "secondary", tooltip: context.$L('uxp-core.text.next'), onClick: () => scroll(1) })] });
};
export default SummaryStrip;
